<span (click)="preventRoutingActions($event)"
      class="badge-gifts-icon align-items-center"
      tooltip="{{ 'SHARED.BADGE-GIFTS.DESCRIPTION' | translate }}"
      [isDisabled]="!enableTooltip">
  <i-feather name="gift"
             class="stroke-1 text-white"></i-feather>
</span>
<ng-content></ng-content>
